/**
 * @file
 */

import { CreateTHEADSectionGV } from "@/common/common.js";

export function InitializeFindFormListPage() {
  CreateTHEADSectionGV("gvForms1");
  CreateTHEADSectionGV("gvForms2");

  $('.responsiveTable').DataTable({
    "responsive": true,
    "scrollX": false,
    "paging": false,
    "searching": false,
    "ordering": false,
    "info": false
  });

  $("#divMofelpDialog").dialog({
    modal: true,
    autoOpen: false,
    title: "Informational Message:",
    width: 560,
    buttons: [
      {
        id: "btnOK",
        text: "OK",
        click: function () {
          var href = $(this).dialog("option", "href");
          window.open(href);
          $(this).dialog('close');
        }
      },
      {
        id: "btnCancel",
        text: "Cancel",
        click: function () {
          $(this).dialog('close');
        }
      }
    ]
  });

  // This click event applies to all the download English links on the findFormList page.  A class is being applied to each of the
  // anchors that has the docID embedded in it.  The docID is extracted and used in the query parameter of the viewForm.aspx page.
  $("a[class^='downloadLink']").click(function () {
    var className = $(this)[0].className;
    var mySplit = className.split(" ");
    var docID = mySplit[0].substring(12);

    $("[id$='divMofelpDialog']").dialog("option", "href", "/DL/secure/borrower/viewForm.aspx?DocId=" + docID + "&Language=English")
    $("[id$='divMofelpDialog']").dialog('open');

  });

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-15
  window.Deliquent = Deliquent;
}

function Deliquent() {
  return confirm('Based on your account status you are not allowed to apply for due date change request. If you have any questions please Contact Us.');
}
